var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        visible: _vm.visible,
        width: "360px",
        "show-close": false,
        "close-on-click-modal": false,
        "destroy-on-close": "",
        "custom-class": "reject-statement-dialog",
      },
      on: {
        "update:visible": function ($event) {
          _vm.visible = $event
        },
        closed: _vm.handleClosed,
      },
    },
    [
      _c(
        "el-form",
        {
          ref: "formRef",
          staticClass: "reject-form",
          attrs: {
            model: _vm.form,
            rules: _vm.rules,
            "label-width": "96px",
            size: "small",
          },
        },
        [
          _c(
            "el-form-item",
            { attrs: { label: "驳回原因：", prop: "rejectReason" } },
            [
              _c("el-input", {
                attrs: {
                  type: "textarea",
                  rows: 4,
                  placeholder: "请输入",
                  maxlength: "500",
                },
                model: {
                  value: _vm.form.rejectReason,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "rejectReason", $$v)
                  },
                  expression: "form.rejectReason",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "reject-footer",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c(
            "el-button",
            {
              attrs: { size: "small" },
              on: {
                click: function ($event) {
                  _vm.visible = false
                },
              },
            },
            [_vm._v("取消")]
          ),
          _vm._v(" "),
          _c(
            "el-button",
            {
              attrs: {
                size: "small",
                type: "primary",
                loading: _vm.submitLoading,
              },
              on: { click: _vm.handleSubmit },
            },
            [_vm._v("确定")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }